import { CollapsedMarketsType } from '../../features/customerPanel/cpPlayerProfile/interface/interface';

export const configDSAccordion = {
	debounceTime: 500,
};
export const updateAccordtionState = (
	collapsedMarkets: CollapsedMarketsType,
	section: keyof CollapsedMarketsType,
	typeKey: number | string,
	typeValue: number | string,
): CollapsedMarketsType => {
	const currentSection = collapsedMarkets?.[section];
	const currentArray: (number | string)[] = currentSection?.[typeKey] ?? [];
	if (currentArray.length && currentArray.includes(typeValue)) {
		const updatedArray = currentArray.filter((v: number | string) => v !== typeValue);
		if (updatedArray.length === 0) {
			const { [typeKey]: _, ...rest } = currentSection;
			return {
				...collapsedMarkets,
				[section]: rest,
			};
		}

		return {
			...collapsedMarkets,
			[section]: {
				...currentSection,
				[typeKey]: updatedArray,
			},
		};
	}
	return {
		...collapsedMarkets,
		[section]: {
			...currentSection,
			[typeKey]: [...currentArray, typeValue],
		},
	};
};
